import { render, staticRenderFns } from "./StageQuickApproveOrReject.vue?vue&type=template&id=46c60508&scoped=true"
import script from "./StageQuickApproveOrReject.vue?vue&type=script&lang=js"
export * from "./StageQuickApproveOrReject.vue?vue&type=script&lang=js"
import style0 from "./StageQuickApproveOrReject.vue?vue&type=style&index=0&id=46c60508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c60508",
  null
  
)

export default component.exports